import { User } from "./user.types";

export enum FileType {
    PROFILE_PICTURE = "profile_picture", // Profil resmi
    DOCUMENT = "document", // Belgeler
    OTHER = "other", // Diğer
    LEAVE = "leave" // İzin belgesi
}

export enum DocumentType {
    ID_CARD = "id_card",
    ID_PHOTO = "id_photo",
    PASSPORT = "passport",
    DRIVER_LICENSE = "driver_license",
    DIPLOMA = "diploma",
    CERTIFICATE = "certificate",
    HEALTH_REPORT = "health_report",
    CRIMINAL_RECORD = "criminal_record",
    RESIDENCE = "residence",
    SGK_ENTRY_DOCUMENT = "sgk_entry_document", // SGK İşe Giriş Belgesi
    EMPLOYMENT_CONTRACT = "employment_contract", // İş Sözleşmesi
    MILITARY_SERVICE_CERTIFICATE = "military_service_certificate", // Askerlik Durum Belgesi
}



// DocumentType Türkçe karşılıkları
export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
    [DocumentType.ID_CARD]: "Kimlik Kartı",
    [DocumentType.ID_PHOTO]: "Kimlik Fotoğrafı",
    [DocumentType.PASSPORT]: "Pasaport",
    [DocumentType.DRIVER_LICENSE]: "Ehliyet",
    [DocumentType.DIPLOMA]: "Diploma",
    [DocumentType.CERTIFICATE]: "Sertifika",
    [DocumentType.HEALTH_REPORT]: "Sağlık Raporu",
    [DocumentType.CRIMINAL_RECORD]: "Adli Sicil Belgesi",
    [DocumentType.RESIDENCE]: "İkametgah Belgesi",
    [DocumentType.SGK_ENTRY_DOCUMENT]: "SGK İşe Giriş Belgesi",
    [DocumentType.EMPLOYMENT_CONTRACT]: "İş Sözleşmesi",
    [DocumentType.MILITARY_SERVICE_CERTIFICATE]: "Askerlik Durum Belgesi"
};

// DocumentType seçeneklerini dropdown için hazırla
export const getDocumentTypeOptions = () => {
    return Object.entries(DOCUMENT_TYPE_LABELS).map(([value, label]) => ({
        value,
        label
    }));
};

export interface FileDto {
    id: number;
    name: string;
    path: string;
    type: FileType;
    size: number;
    user?: User;
    documentType?: DocumentType | null; // Belge tipi (nullable)
    isVisible?: boolean; // Görünürlük durumu
    createdAt: Date;
    updatedAt: Date;
}

export interface FileUploadRequest {
    file: File;
    type: FileType;
    name?: string;
}

export interface FileUploadResponse {
    filePath: {

        id: number;
        name: string;
        path: string;
        type: FileType;
        size: number;
        createdAt: Date;
        updatedAt: Date;
    }
}
